import { Icon as ChakraIcon, IconProps } from '@chakra-ui/react'
import type { IconType } from '@react-icons/all-files/lib/esm/iconBase'
import * as React from 'react'

import { useAnyFgColorValue } from '~theme/fgColor'

// ! when including icons the default way, the whole packs of icons made it into the bundle (not just the individual ones)
// more info on the problem & solutions here: https://github.com/react-icons/react-icons/issues/154#issuecomment-895976123
// (linked comment is the solution I tried to go with and it seems to work)

type TChakraProps = Pick<
  IconProps,
  'minWidth' | 'marginLeft' | 'marginRight' | 'minHeight' | 'strokeWidth' | 'verticalAlign'
>
type TColorOptions = FirstParam<typeof useAnyFgColorValue>

type TProps = NoChildren &
  TChakraProps &
  TColorOptions & {
    /**
     * component, usually imported from `react-icons`
     */
    icon: IconType
    /**
     * CSS value with unit, like `1.5rem`
     */
    iconSize?: string
  }

/**
 * Custom Chakra Icon component
 */
export const Icon: React.FC<TProps> = ({
  icon,
  iconSize = `1.5rem`,
  color,
  contrast = `normal`,
  ...chakraProps
}) => {
  const iconColor = useAnyFgColorValue({ color, contrast })

  return <ChakraIcon {...chakraProps} as={icon} boxSize={iconSize} color={iconColor} />
}
